import React, { useEffect, useState } from 'react'
import Select from 'react-select'
import { getPerspectives } from '../../api/perspective'
import ModalConfigExclusiveFilters, { BtnExclusiveFilter } from './ModalConfigExclusiveFilters'
import ModalConfigInclusiveFilters, { BtnFilter } from './ModalConfigInclusiveFilters'

interface IProps {
    perspectives: any[]
    btnFiltersOR?: BtnFilter[]
    btnFiltersAND?: BtnExclusiveFilter[]
    onChange: any
    maxSpeed: number
}

const ConfigMapMarkers = ({ onChange, perspectives, btnFiltersOR = [], btnFiltersAND = [], maxSpeed }: IProps) => {
    const [perspectivesDB, setPerspectivesDB] = useState<any[]>()
    const [perspectivesSelected, setPerspectivesSelected] = useState(perspectives)
    const [showModalFiltersOR, setShowModalFiltersOR] = useState<boolean>(false)
    const [showModalFiltersAND, setShowModalFiltersAND] = useState<boolean>(false)
    const [maxSpeedSelected, setMaxSpeedSelected] = useState<number>(maxSpeed)

    useEffect(() => {
        getPerspectives().then((response: any) => {
            const perspectives: any[] = response.data.data.map(({ name, id }) => ({ value: id, label: name }))
            setPerspectivesDB(perspectives)
        })
    }, [])

    const handleChange = target => {
        onChange('perspectives', target)
        setPerspectivesSelected(target)
    }

    const hideModalFiltersOR = () => {
        setShowModalFiltersOR(false)
    }

    const hideModalFiltersAND = () => {
        setShowModalFiltersAND(false)
    }

    const handleMaxSpeed = ({ target }) => {
        onChange('maxSpeed', target.value)
        setMaxSpeedSelected(target.value)
    }

    return (
        <div className="main">
            <label>Restricted Perspectives</label>

            <Select
                multi
                value={perspectivesSelected}
                onChange={handleChange}
                name="perspectives"
                options={perspectivesDB}
                className="basic-multi-select"
            />

            <div>
                <label>Max Speed</label>
                <input type="number" min={1} value={maxSpeedSelected} onChange={handleMaxSpeed} />
            </div>

            <br />

            <button onClick={() => setShowModalFiltersOR(true)} className="btn btn-edit has-icon fixed-size">
                <i className="fas fa-layer-group" />
                <span className="btn-label label-bold">CONFIGURAR FILTROS OU</span>
                <i className="fa fa-pencil" />
            </button>

            <ModalConfigInclusiveFilters
                btnFiltersOR={btnFiltersOR}
                show={showModalFiltersOR}
                hide={hideModalFiltersOR}
                onChange={filters => onChange('btnFiltersOR', filters)}
            />

            <br />
            <br />

            <button onClick={() => setShowModalFiltersAND(true)} className="btn btn-edit has-icon fixed-size">
                <i className="fas fa-layer-group" />
                <span className="btn-label label-bold">CONFIGURAR FILTROS AND</span>
                <i className="fa fa-pencil" />
            </button>

            <ModalConfigExclusiveFilters
                btnFiltersAND={btnFiltersAND}
                show={showModalFiltersAND}
                hide={hideModalFiltersAND}
                onChange={filters => onChange('btnFiltersAND', filters)}
            />
        </div>
    )
}

export default ConfigMapMarkers
